import { Injectable } from '@angular/core';
import { ApiService } from '@services/api/api.service';
import { tap } from 'rxjs/operators';
import { StateCacheFetchService } from '@state-management/services/state-cache-fetch.service';
import { getTagSetting } from '@state-management/reducers';

@Injectable({
  providedIn: 'root',
})
export class TagMangerService {
  constructor(
    private api: ApiService,
    private cacheFetch: StateCacheFetchService
  ) {}

  /** See SettingService.invalidateTagCache — same reasoning, the other service that writes tags. */
  private invalidateTagCache<T>() {
    return tap<T>(() => this.cacheFetch.invalidate(getTagSetting));
  }

  addTag(payload: any) {
    return this.api.post('/general/tag-manager/', payload).pipe(this.invalidateTagCache());
  }

  createTag(payload: any) {
    return this.api.post('/general/tag-settings/', payload).pipe(this.invalidateTagCache());
  }

  requestTag(payload: any) {
    return this.api.post('/general/request-tag/', payload);
  }

  getProjectStatus = () => {
    return this.api.get(`/general/tag-manager/get-by-filters?office_id=${this.api.getOfficeId()}&mslug=project&tslug=project-status`);
  };
}
